import { cn } from "@repo/design-system/utils";
import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

/**
 * "Back to Cart" for the checkout step actions. Shared so the link reads the
 * same wherever the step places it.
 */
export function BackToCartLink({ className }: { className?: string }) {
  return (
    <Link
      to="/cart"
      className={cn(
        "inline-flex items-center gap-1 rounded text-sm font-medium text-purple-600 hover:text-purple-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2",
        className
      )}
    >
      <ArrowLeft className="h-4 w-4" aria-hidden="true" />
      Back to Cart
    </Link>
  );
}
